import { render, staticRenderFns } from "./NormalHeaderLayout.vue?vue&type=template&id=0c5f87c8&scoped=true&"
import script from "./NormalHeaderLayout.vue?vue&type=script&lang=js&"
export * from "./NormalHeaderLayout.vue?vue&type=script&lang=js&"
import style0 from "./NormalHeaderLayout.vue?vue&type=style&index=0&id=0c5f87c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5f87c8",
  null
  
)

export default component.exports